import { Navigate, Outlet, useLocation } from "react-router-dom";
import { constant } from "./constants";
import { useAppSelector } from "./redux/hooks";
import {
  getDomainUrl,
  getURLDomain,
  getURLPath,
  getURLToLoad,
} from "./components/forms/utility";
import { useMemo } from "react";

export const Admin = () => {
  let jwtToken = localStorage.getItem("jwtToken");
  const location = useLocation();
  const groups = localStorage.getItem("groups");
  const urlTOload = useMemo(() => {
    return getURLToLoad();
  }, []);

  if (!jwtToken || !groups) {
    return <Navigate to={`/${urlTOload}`} state={{ from: location }} replace />;
  }
  return <Outlet />;
};

export const CustomerServiceAdmin = () => {
  const location = useLocation();
  const groups = localStorage.getItem("groups");
  const userRole = groups ? JSON.parse(groups) : [];
  const customerRole = constant.CustomerServiceAdmin;

  return userRole.find((role: any) => customerRole.includes(role)) ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};
